import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import logout from "../../image/logout.png";
import ModalCommon from "../Modal";
import { useLocation } from "react-router-dom";
import { TEXT_DEF } from "../../constant/text";
import moment from "moment";

const TEXT = {
  manager_account: 'Quản lý tài khoản',
  history: 'Lịch sử',
  gamingHis: 'Lịch sử chơi',
  conversionHis: 'Lịch sử quy đổi DTC',
  playHis: 'Lịch sử lượt chơi',
  mannager_game: 'Quản lý game',
  popup_fake_user: 'Quản lý popup trúng thưởng lớn',
  setup_countdown: 'Bật tắt game',
  setup_condition: 'Cài đặt điều kiện',
  setup_score: 'Cài đặt điểm nhận',
  setup_gameplay: 'Cài đặt tốc độ & vật phẩm',
  setup_rule: 'Cài đặt thể lệ',
  update_turn: 'Thêm/bớt lượt chơi',
  rank_setup: 'Quản lý bảng xếp hạng',
  rank_list: 'Bảng xếp hạng'
}

const { Header } = Layout;

const HeaderCustom = ({ username, collapsed, updateCollapsed }) => {
  const [isShowModal, setIsShowModal] = useState();
  const [titleScreen, setTitleScreen] = useState();
  const location = useLocation();
  const [timeSystem, setTimeSystem] = useState("Loading");

  useEffect(() => {
    if (username) {
      setInterval(() => {
        const timeSys = moment().utcOffset(7).format('DD/MM/YYYY HH:mm:ss');
        const arr = timeSys.split(" ");
        const timeView = `${arr[1]} GMT+7 ${arr[0]}`;
        setTimeSystem(timeView)
      }, 1000);
    }
  })

  useEffect(() => {
    let title;
    if (
      location.pathname.indexOf("/editAccount/") > -1 ||
      location.pathname.indexOf("/createRankByUser/") > -1
    ) {
      location.pathname = "/editAccount/";
    }

    switch (location.pathname) {
      case "/account":
        title = TEXT_DEF.manager_account;
        break;
      case "/createAccount":
        title = TEXT_DEF.text0028;
        break;
      case "/conversionHis":
        title = TEXT.conversionHis;
        break;
      case "/playHis":
        title = TEXT.playHis;
        break;
      case "/gamingHis":
        title = TEXT.gamingHis;
        break;
      case "/setup_countdown":
        title = TEXT.setup_countdown;
        break;
      case "/setup_condition":
        title = TEXT.setup_condition;
        break;
      case "/setup_score":
        title = TEXT.setup_score;
        break;
      case "/setup_gameplay":
        title = TEXT.setup_gameplay;
        break;
      case "/setup_rule":
        title = TEXT.setup_rule;
        break;
      case "/update_turn":
        title = TEXT.update_turn;
        break;
      case "/rank_setup":
        title = TEXT.rank_setup;
        break;
      case "/rankList":
        title = TEXT.rank_list;
        break;
      case "/popup_fake_user":
        title = TEXT.popup_fake_user;
        break;

      default:
        title = "";
        break;
    }
    setTitleScreen(title);
  }, [location]);

  return (
    <>
      <Header className="site-layout-background" style={{ padding: 0 }}>
        <div className="header-cus">
          <div style={{ display: "flex", alignItems: "center" }}>
            {collapsed ? (
              <MenuUnfoldOutlined
                className="trigger menu-icon"
                onClick={updateCollapsed}
              />
            ) : (
              <MenuFoldOutlined
                className="trigger menu-icon"
                onClick={updateCollapsed}
              />
            )}
            <span style={{ fontSize: 18, fontWeight: 700 }}>{titleScreen}</span>
          </div>

          <div className="header-right">
            <div className="time-system">
              <span>Ngày giờ hệ thống: </span>
              <span style={{ marginLeft: 5 }}>{timeSystem}</span>
            </div>
            <span>{username}</span>
            <img
              className="img-logout"
              src={logout}
              alt="logout"
              onClick={() => setIsShowModal(true)}
            />
          </div>
        </div>
      </Header>
      {isShowModal && (
        <ModalCommon
          isShow={isShowModal}
          message={TEXT_DEF.text0022}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={() => {
            setIsShowModal(false);
            localStorage.clear();
            window.location.assign("/login");
          }}
          close={() => setIsShowModal(false)}
        />
      )}
    </>
  );
};

export default HeaderCustom;
